import React, { useState } from 'react';
import BottomTabBar from '../components/util/BottomTabBar';
import Header from '../components/util/Header';
import GlobalSearchModal from '../modal/GlobalSearchModal';
import './StorePage.css';

const PointShop = () => {

  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <>
    <div className="container">
      <Header useLogo={true} modalOpen={()=>setIsModalOpen(true)}/>
      <img src="/pointshop_full.png" style={{width: '100%'}} alt="pointshop" />
      <BottomTabBar/>
    </div>
     {isModalOpen && (
      <>
      <div className="modal-wrapper">
          <GlobalSearchModal onClose={()=>setIsModalOpen(false)}/>
      </div>
      </>)}
  </>
  );
};

export default PointShop; 